import Vue from 'vue'
import moment from 'moment'
import axios from 'axios'
import * as types from '../mutation-types'

// functions
const checkRequired = (reqLen, maxLen, selected) => {
  if (!reqLen) {
    return true
  }
  if (reqLen === 1) {
    return Array.isArray(selected) ? selected.length >= reqLen : !!(selected)
  }
  return !!(selected && (!maxLen ? selected.length === reqLen : selected.length >= reqLen && selected.length <= maxLen))
}

export const checkAvailableSchema = (availableSchemas, current) => {
  let displayMode = 0 // 0- enabled, 1- disabled, 2- hidden
  let curIasList = []
  availableSchemas.forEach(a => {
    let inRange = false
    let isActive = false

    const t = a.AvailableTimeRange.split('-')
    const t2 = {
      start: t[0].split(':').map(d => parseInt(d)),
      end: t[1].split(':').map(d => parseInt(d))
    }
    const t3 = {
      start: t2.start[0] + (t2.start[1] / 60),
      end: t2.end[0] + (t2.end[1] / 60)
    }
    const startTime = t3.start
    const endTime = t3.end
    const timeOfDay = current.t
    const currentDayOfWeek = current.n
    const d = a.AvailableDaysOfWeek === '0' ? '1,2,3,4,5,6,7' : a.AvailableDaysOfWeek
    const daysOfWeek = d.split(',').map(i => parseInt(i))

    let today = moment(current.d)
    let startDate = moment('0001-01-01')
    let endDate = moment('9999-12-31')

    if (startTime < endTime) {
      if (timeOfDay >= startTime && timeOfDay <= endTime) isActive = true
    } else {
      if (startTime == endTime || timeOfDay >= startTime || timeOfDay <= endTime) {
        isActive = true
        if (timeOfDay <= endTime) today = today.subtract(1, 'day')
      }
    }
    if (a.AvailableStartDate && a.AvailableStartDate.length > 0) {
      startDate = moment(a.AvailableStartDate)
    }
    if (a.AvailableEndDate && a.AvailableEndDate.length > 0) {
      endDate = moment(a.AvailableEndDate)
    }
    if (isActive) {
      if (today < startDate || today > endDate) isActive = false
    }
    const includeToday = daysOfWeek.includes(currentDayOfWeek)
    inRange = isActive && includeToday
    const isHoliday = current.w
    const includeHoliday = a.AvailableDays !== '-H'

    const inRangeDisplayMode = !a.Invalid ? 0 : parseInt(a.Invalid)
    const outRangeDisplayMode = inRangeDisplayMode != 0 ? 0
      : (!a.OutOfRangeVisibility ? 1 : 2 - parseInt(a.OutOfRangeVisibility))

    if (!includeHoliday && isHoliday && inRange) inRange = false

    displayMode = inRange ? inRangeDisplayMode : outRangeDisplayMode

    curIasList.push({
      ID: a.ID,
      inRange: inRange,
      displayMode: displayMode
    })

    if (inRange) return
  })
  const ias = curIasList.find(i => i.inRange)
  if (ias) displayMode = ias.displayMode

  return displayMode
}

const buildRecurCourseItems = (status, required, item, menuItemCourseItems, newCourseItemIds, newCourseItems, level) => {
  if (item && item.courses && item.courses.length > 0) {
    level++
    item.courses.forEach(i1 => {
      if (status.value && !checkRequired(i1.req_len, i1.max_len, i1.selected)) {
        status.value = false
        required.push(i1.name)
      }
      if (i1.selected) {
        if (Array.isArray(i1.selected)) {
          i1.selected.forEach(id => {
            newCourseItemIds.push(id)
            const i2 = menuItemCourseItems.find(i => i.item_id === id)
            if (i2) {
              Vue.set(i2, 'level', level)
              newCourseItems.push(i2)
            } else {
              const i3 = i1.course_items.find(i => i.item_id === id)
              Vue.set(i3, 'level', level)
              if (i3.has_courses === 1 && i3.courses && i3.courses.filter(c => c.selected && ((Array.isArray(c.selected) && c.selected.length > 0) || (!Array.isArray(c.selected)))).length > 0) {
                Vue.set(i3, 'isItemSetMeal', 1)
              }
              newCourseItems.push(buildCourseItem(i3))
              if (i3.has_courses === 1) {
                buildRecurCourseItems(status, required, i3, menuItemCourseItems, newCourseItemIds, newCourseItems, level)
              }
            }
          })
          // Clear non-selected
          i1.course_items.filter(i => !i1.selected.includes(i.item_id)).forEach(courseitem => {
            if (courseitem.has_courses === 1 && courseitem.courses) {
              courseitem.courses = cleanRecurCourseItems(courseitem.courses)
            }
          })
        } else {
          newCourseItemIds.push(i1.selected)
          const i2 = menuItemCourseItems.find(i => i.item_id === i1.selected)
          if (i2) {
            Vue.set(i2, 'level', level)
            newCourseItems.push(i2)
          } else {
            const i3 = i1.course_items.find(i => i.item_id === i1.selected)
            Vue.set(i3, 'level', level)
            if (i3.has_courses === 1 && i3.courses && i3.courses.filter(c => c.selected && ((Array.isArray(c.selected) && c.selected.length > 0) || (!Array.isArray(c.selected)))).length > 0) {
              Vue.set(i3, 'isItemSetMeal', 1)
            }
            newCourseItems.push(buildCourseItem(i3))
            if (i3.has_courses === 1) {
              buildRecurCourseItems(status, required, i3, menuItemCourseItems, newCourseItemIds, newCourseItems, level)
            }
          }
          // Clear non-selected
          i1.course_items.filter(i => i.item_id != i1.selected).forEach(courseitem => {
            if (courseitem.has_courses === 1 && courseitem.courses) {
              courseitem.courses = cleanRecurCourseItems(courseitem.courses)
            }
          })
        }
      }
    })
  }
}

const cleanRecurCourseItems = (courses) => {
  const courses2 = courses.map(course => {
    let reqLen
    let selected
    let selector
    let multiple
    const maxLen = course.maximum_choice
    if (course.minimum_choice === 0) {
      reqLen = null
      selector = 'checkbox'
      selected = []
      if (maxLen === 1) {
        multiple = false
      } else {
        multiple = true
      }
    } else {
      reqLen = course.minimum_choice
      if (maxLen === 1) {
        selector = 'radio'
        selected = course.course_items.length === 1 ? course.course_items[0].item_id : null
        // selected = null
        multiple = false
      } else {
        selector = 'checkbox'
        selected = []
        multiple = true
      }
    }
    if (course.course_items && course.course_items.length > 0) {
      const course2 = course
      course2.course_items = course.course_items.map(courseitem => {
        if (courseitem.has_courses === 1 && courseitem.courses) {
          courseitem.courses = cleanRecurCourseItems(courseitem.courses)
        }
        return { ...courseitem }
      })
      course = course2
    }
    return {
      ...course,
      selector: selector,
      selected: selected,
      req_len: reqLen,
      max_len: maxLen,
      multiple: multiple
    }
  })
  return courses2
}

const buildCourseItem = item => ({
  item_id: item.course_item_id,
  name: item.name,
  plu_id: item.plu_id,
  price: item.price,
  price_override: item.price_override,
  priceow: item.price_override,
  quantity: 1,
  qty: 1, // Accepted by POS
  tax: item.tax,
  pluID: item.plu_id, // Accepted by POS
  setCourseItemID: item.course_item_id, // Accepted by POS
  service_charge: item.service_charge,
  time_required: item.time_required,
  tray_count: item.tray_count,
  is_set_meal: item.is_set_meal,
  non_discount: item.non_discount,
  photo_url: item.photo_url,
  courseLevel: item.level || 0,
  isItemSetMeal: item.isItemSetMeal || 0,
  alternativeName: item.alternate_name || item.name
})

const buildModifier = option => ({
  modifier_id: option.option_id,
  name: option.name,
  alternativeName: option.alternate_name || option.name,
  price: option.price,
  quantity: 1,
  pos_item_id: option.pos_item_id,
  non_discount: option.non_discount,
  photo_url: option.photo_url,
  modiid: option.option_id,
  modiPrice: option.price, // Accepted by POS
  modiName: option.name
})

// namespaced
export const namespaced = true

// state
export const state = {
  msg: null,
  items: {},

  modeCats: [],
  catList: [],
  parentCats: [],
  childrenCatList: [],
  mainCat: null,

  itemStatus: null,

  menuItemDialog: false,
  menuItem: null,
  menuItemPrice: null,
  menuItemQty: null,
  menuItemCourseItems: [],
  menuItemOptions: [],
  menuItemToppings: [],
  menuItemReady: null,
  menuItemRequired: [],
  menuItemSpecialReq: null,

  catListDialog: false,

  submenu: [],
  selectedPanel: null
}

// getters
export const getters = {
  menuMsg: state => state.msg,
  items: state => state.items,

  modeCats: state => state.modeCats,
  catList: state => state.catList,
  catListIds: state => state.catList.map(c => c.category_id),
  parentCats: state => state.parentCats,
  childrenCatList: state => state.childrenCatList,
  mainCat: state => state.mainCat,

  menuItemStatus: state => state.itemStatus,

  menuItemDialog: state => state.menuItemDialog,
  menuItem: state => state.menuItem,
  menuItemPrice: state => state.menuItemPrice,
  menuItemQty: state => state.menuItemQty,
  menuItemCourseItems: state => state.menuItemCourseItems,
  menuItemOptions: state => state.menuItemOptions,
  menuItemToppings: state => state.menuItemToppings,
  menuItemReady: state => state.menuItemReady,
  menuItemRequired: state => state.menuItemRequired,
  menuItemSpecialReq: state => state.menuItemSpecialReq,

  catListDialog: state => state.catListDialog,

  submenu: state => state.submenu,
  selectedPanel: state => state.selectedPanel
}

// mutations
export const mutations = {
  [types.RESET_MENU_DATA] (state) {
    Object.assign(state, {
      msg: null,
      items: {},

      modeCats: [],
      catList: [],
      parentCats: [],
      childrenCatList: [],
      mainCat: null,

      itemStatus: null,

      menuItemDialog: false,
      menuItem: null,
      menuItemPrice: null,
      menuItemQty: null,
      menuItemCourseItems: [],
      menuItemOptions: [],
      menuItemToppings: [],
      menuItemReady: null,
      menuItemRequired: [],
      menuItemSpecialReq: null,

      catListDialog: false,

      submenu: [],
      selectedPanel: null
    })
  },

  [types.SET_MENU_MSG] (state, msg) {
    const msgs = {
      cat: 'Failed to fetch menu categories',
      item: 'Failed to fetch menu items',
      item2: 'Failed to fetch item status'
    }
    const message = msg ? (msgs[msg] ? msgs[msg] : msg) : 'Failed to fetch data'
    state.msg = message
  },

  [types.RESET_MENU_MSG] (state) {
    state.msg = null
  },

  [types.FETCH_MENU_CATS] (state, { modeCats, catList, parentCats }) {
    state.modeCats = modeCats
    state.catList = catList
    state.parentCats = parentCats
    if (!state.mainCat || (parentCats && !parentCats.find(c => c.category_id === state.mainCat))) {
      state.mainCat = parentCats && parentCats.length > 0 ? parentCats[0].category_id : 0
    }
    state.childrenCatList = catList.filter(c => c.parent_id === state.mainCat)
    state.items = {}
  },

  [types.FETCH_MENU_ITEMS] (state, { cat, items }) {
    const key = 'c' + cat
    Vue.set(state.items, key, items)
  },

  [types.SET_MENU_ITEM_STATUS] (state, status) {
    state.itemStatus = status
  },

  [types.RESET_MENU_ITEM_STATUS] (state) {
    state.itemStatus = null
  },

  [types.SET_MENU_ITEM] (state, payload) {
    // payload is item
    Object.assign(state, {
      menuItem: payload,
      menuItemPrice: parseFloat(payload.final_price || payload.price),
      menuItemQty: payload.quantity || 1,
      menuItemCourseItems: payload.set_course_items || [],
      menuItemOptions: payload.options || [],
      menuItemToppings: payload.toppings || [],
      menuItemReady: null,
      menuItemRequired: [],
      menuItemSpecialReq: payload.remarks || ''
    })
  },

  [types.RESET_MENU_ITEM] (state) {
    Object.assign(state, {
      menuItem: null,
      menuItemPrice: null,
      menuItemQty: null,
      menuItemCourseItems: [],
      menuItemOptions: [],
      menuItemToppings: [],
      menuItemReady: null,
      menuItemRequired: [],
      menuItemSpecialReq: null
    })
  },

  [types.SET_MENU_ITEM_QTY] (state, payload) {
    // payload is qty (integer)
    state.menuItemQty = payload
  },

  [types.CHANGE_MENU_ITEM_QTY] (state, payload) {
    // payload is qty (integer)
    state.menuItemQty = state.menuItemQty + payload
  },

  [types.CHANGE_MENU_ITEM_PRICE] (state, payload) {
    // payload is price (float)
    state.menuItemPrice = parseFloat(state.menuItem.price_override || state.menuItem.price) + parseFloat(payload)
  },

  [types.CHANGE_MENU_ITEM_STATUS] (state, { status, required }) {
    // payload is { status, required }
    state.menuItemReady = status
    state.menuItemRequired = required
  },

  [types.SET_MENU_ITEM_SPECIALREQ] (state, payload) {
    // payload is specialReq
    state.menuItemSpecialReq = payload
  },

  [types.SET_MENU_ITEM_OPTIONS] (state, payload) {
    // payload is array of options (new format, ready for cart)
    state.menuItemOptions = payload
  },

  [types.SET_MENU_ITEM_TOPPINGS] (state, payload) {
    // payload is array of toppings (new format, ready for cart)
    state.menuItemToppings = payload
  },

  [types.SET_MENU_ITEM_COURSE_ITEMS] (state, payload) {
    // payload is array of course items (new format, ready for cart)
    state.menuItemCourseItems = payload
  },

  [types.SHOW_MENU_ITEM_DIALOG] (state) {
    state.menuItemDialog = true
  },

  [types.HIDE_MENU_ITEM_DIALOG] (state) {
    state.menuItemDialog = false
  },

  [types.SET_MAIN_CAT] (state, payload) {
    state.mainCat = payload
    state.childrenCatList = state.catList.filter(c => c.parent_id === payload)
  },

  [types.SHOW_CAT_LIST_DIALOG] (state) {
    state.catListDialog = true
  },

  [types.HIDE_CAT_LIST_DIALOG] (state) {
    state.catListDialog = false
  },

  [types.FETCH_SUBMENU] (state, payload) {
    state.submenu = payload
  },

  [types.SET_SELECTED_PANEL] (state, payload) {
    state.selectedPanel = payload
  },

  [types.RESET_SELECTED_PANEL] (state) {
    state.selectedPanel = null
  }

}

// actions
export const actions = {
  resetMenuData ({ commit }) {
    commit(types.RESET_MENU_DATA)
  },

  async fetchMenuCats ({ commit, rootState, rootGetters }) {
    commit(types.RESET_MENU_MSG)
    let cats = rootGetters['config/cats']
    const noShowCats = rootGetters['config/noShowCats']
    cats = !_.isEmpty(noShowCats) ? cats.filter(c => !noShowCats.includes(c.category_id)) : cats
    const modeData = rootState.config.mode ? rootState.config.mode : rootGetters['config/modes'][0]
    let parents
    const modeCats = []
    if (modeData.cats === 'all') {
      const parentCats = cats.filter(c => parseInt(c.parent_id) === 0)
      const sortedParentCats = parentCats.sort((a, b) => parseInt(a.sequence) - parseInt(b.sequence))
      parents = sortedParentCats
    } else {
      parents = cats.filter(c => modeData.cats.includes(c.category_id))
    }
    parents.forEach(p => {
      const subCats = cats.filter(c => parseInt(c.parent_id) === parseInt(p.category_id))
      const sortedCats = subCats.sort((a, b) => parseInt(a.sequence) - parseInt(b.sequence))
      modeCats.push(...sortedCats)
    })
    const catList = []
    if (modeCats.length > 0) {
      try {
        const selectedDateTime = rootGetters['cart/pickupDate'] && rootGetters['cart/pickupTime'] ? rootGetters['cart/pickupDate'] + ' ' + rootGetters['cart/pickupTime'] : null
        const timeData = await axios.post('/api/moment/current', {
          holidays: rootGetters['config/holidays'],
          date: selectedDateTime
        })
        const currentTime = timeData.data
        modeCats.forEach(c => {
          if (checkAvailableSchema(c.avail_schema, currentTime) === 0) catList.push(c)
        })
      } catch (e) { }
    }
    let parents2 = []
    parents.forEach(p => {
      if (catList.find(c => c.parent_id === p.category_id)) {
        parents2.push(p)
      }
    })
    commit(types.FETCH_MENU_CATS, {
      modeCats: modeCats,
      catList: catList,
      parentCats: parents2
    })
  },

  async fetchCatItems ({ commit, rootGetters }, payload) {
    // payload is category_id
    commit(types.RESET_MENU_MSG)
    try {
      const currentMode = rootGetters['config/mode']
      const { data } = await axios.post('/api/menu/cat/items', {
        restaurant_id: parseInt(rootGetters['config/rid']),
        category_id: payload,
        date: currentMode.isTakeaway || currentMode.isDelivery ? rootGetters['cart/pickupDate'] : null,
        time: currentMode.isTakeaway || currentMode.isDelivery ? rootGetters['cart/pickupTime'] : null
      })
      const itemList = []
      const selectedDateTime = rootGetters['cart/pickupDate'] && rootGetters['cart/pickupTime'] ? rootGetters['cart/pickupDate'] + ' ' + rootGetters['cart/pickupTime'] : null
      const timeData = await axios.post('/api/moment/current', {
        holidays: rootGetters['config/holidays'],
        date: selectedDateTime
      })
      const currentTime = timeData.data
      data.forEach(c => {
        if (checkAvailableSchema(c.avail_schema, currentTime) === 0) itemList.push(c)
      })
      if (itemList && itemList.length > 0) {
        const items = itemList.map(item => {
          if ((item.courses && item.courses.length > 0) || (item.option_groups && item.option_groups.length > 0)) {
            const item2 = item
            if (item.courses && item.courses.length > 0) {
              const courses = item.courses.map(course => {
                let reqLen
                let selected
                let selector
                let multiple
                const maxLen = course.maximum_choice
                if (course.minimum_choice === 0) {
                  reqLen = null
                  selector = 'checkbox'
                  selected = []
                  if (maxLen === 1) {
                    multiple = false
                  } else {
                    multiple = true
                  }
                } else {
                  reqLen = course.minimum_choice
                  if (maxLen === 1) {
                    selector = 'radio'
                    selected = course.course_items.length === 1 ? course.course_items[0].item_id : null
                    multiple = false
                  } else {
                    selector = 'checkbox'
                    selected = []
                    multiple = true
                  }
                }
                return {
                  ...course,
                  selector: selector,
                  selected: selected,
                  req_len: reqLen,
                  max_len: maxLen,
                  multiple: multiple
                }
              })
              item2.courses = courses
            }
            if (item.option_groups && item.option_groups.length > 0) {
              const options = item.option_groups.map(option => ({
                ...option,
                selector: (option.is_multiple === 1) ? 'checkbox' : 'radio',
                selected: (option.is_multiple === 1) ? [] : null,
                req_len: (option.is_optional === 0 && option.is_multiple === 0) ? 1 : null
              }))
              item2.option_groups = options
            }
            return item2
          }
          return item
        })
        commit(types.FETCH_MENU_ITEMS, {
          cat: payload,
          items: items
        })
      } else {
        commit(types.SET_MENU_MSG, 'item')
      }
    } catch (e) {
      commit(types.SET_MENU_MSG, 'item')
    }
  },

  // Not in used
  async checkItemStatus ({ commit, rootGetters }, payload) {
    // payload is item
    commit(types.RESET_MENU_MSG)
    commit(types.RESET_MENU_ITEM_STATUS)
    try {
      const { data } = await axios.post('/api/menu/items/status', {
        restaurant_id: parseInt(rootGetters['config/rid']),
        category_id: payload.category_id,
        item_id: payload.item_id
      })
      commit(types.SET_MENU_ITEM_STATUS, data)
    } catch (e) {
      commit(types.SET_MENU_MSG, 'item2')
    }
  },

  setMenuItem ({ commit }, payload) {
    // payload is item
    commit(types.SET_MENU_ITEM, payload)
  },

  resetMenuItem ({ commit }) {
    commit(types.RESET_MENU_ITEM)
  },

  setMenuItemQty ({ commit }, payload) {
    // payload is qty
    commit(types.SET_MENU_ITEM_QTY, payload)
  },

  changeMenuItemQty ({ commit }, payload) {
    // payload is qty
    commit(types.CHANGE_MENU_ITEM_QTY, payload)
  },

  changeMenuItemPrice ({ commit }, payload) {
    // payload is price
    commit(types.CHANGE_MENU_ITEM_PRICE, payload)
  },

  setMenuItemSpecialReq ({ commit }, payload) {
    // payload is specialReq
    commit(types.SET_MENU_ITEM_SPECIALREQ, payload)
  },

  showMenuItemDialog ({ commit, dispatch }, payload) {
    // payload is item
    commit(types.SHOW_MENU_ITEM_DIALOG)
    dispatch('setMenuItem', payload)
  },

  hideMenuItemDialog ({ commit, dispatch }) {
    commit(types.HIDE_MENU_ITEM_DIALOG)
    dispatch('cleanMenuItem')
    dispatch('resetMenuItem')
  },

  async processMenuItem ({ commit, state }, payload) {
    // payload is string: course, modifier, both
    let status = new Object()
    status.value = true
    const required = []
    const newCourseItemIds = []
    const newCourseItems = []
    const level = 0
    if (payload === 'course' || payload === 'both') {
      buildRecurCourseItems(status, required, state.menuItem, state.menuItemCourseItems, newCourseItemIds, newCourseItems, level)
      // comment out to handle empty course items
      // if (newCourseItemIds.length > 0) {
      await commit(types.SET_MENU_ITEM_COURSE_ITEMS, newCourseItems)
      const price = (newCourseItems.length > 0) ? newCourseItems.map(i => parseFloat(i.price_override)).reduce((a, b) => a + b) : 0
      if (state.menuItem) {
        await commit(types.CHANGE_MENU_ITEM_PRICE, price)
      }
      // }
    }
    if (payload === 'modifier' || payload === 'both') {
      if (state.menuItem.option_groups && state.menuItem.option_groups.length > 0) {
        const newToppingIds = []
        const newToppings = []
        const newOptionIds = []
        const newOptions = []
        state.menuItem.option_groups.forEach(i1 => {
          if (status.value && !checkRequired(i1.req_len, i1.max_len, i1.selected)) {
            status.value = false
            required.push(i1.name)
          }
          if (i1.selected) {
            if (Array.isArray(i1.selected)) {
              if (i1.name === 'EXTRA TOPPINGS') {
                i1.selected.forEach(id => {
                  if (!newToppingIds.includes(id)) {
                    newToppingIds.push(id)
                    const i2 = state.menuItemToppings.find(i => i.option_id === id)
                    if (i2) {
                      newToppings.push(i2)
                    } else {
                      const i3 = i1.options.find(i => i.option_id === id)
                      newToppings.push(buildModifier(i3))
                    }
                  }
                })
              } else {
                i1.selected.forEach(id => {
                  if (!newOptionIds.includes(id)) {
                    newOptionIds.push(id)
                    const i2 = state.menuItemOptions.find(i => i.option_id === id)
                    if (i2) {
                      newOptions.push(i2)
                    } else {
                      const i3 = i1.options.find(i => i.option_id === id)
                      newOptions.push(buildModifier(i3))
                    }
                  }
                })
              }
            } else {
              if (i1.name === 'EXTRA TOPPINGS') {
                if (!newToppingIds.includes(i1.selected)) {
                  newToppingIds.push(i1.selected)
                  const i2 = state.menuItemToppings.find(i => i.option_id === i1.selected)
                  if (i2) {
                    newToppings.push(i2)
                  } else {
                    const i3 = i1.options.find(i => i.option_id === i1.selected)
                    newToppings.push(buildModifier(i3))
                  }
                }
              } else {
                if (!newOptionIds.includes(i1.selected)) {
                  newOptionIds.push(i1.selected)
                  const i2 = state.menuItemOptions.find(i => i.option_id === i1.selected)
                  if (i2) {
                    newOptions.push(i2)
                  } else {
                    const i3 = i1.options.find(i => i.option_id === i1.selected)
                    newOptions.push(buildModifier(i3))
                  }
                }
              }
            }
          }
        })
        await commit(types.SET_MENU_ITEM_TOPPINGS, newToppings)
        await commit(types.SET_MENU_ITEM_OPTIONS, newOptions)
        const price1 = (newToppings.length > 0) ? newToppings.map(i => parseFloat(i.price)).reduce((a, b) => a + b) : 0
        const price2 = (newOptions.length > 0) ? newOptions.map(i => parseFloat(i.price)).reduce((a, b) => a + b) : 0
        await commit(types.CHANGE_MENU_ITEM_PRICE, price1 + price2)
      }
    }
    status = status.value
    await commit(types.CHANGE_MENU_ITEM_STATUS, { status, required })
  },

  cleanMenuItem ({ commit, state }) {
    if ((state.menuItem.courses && state.menuItem.courses.length > 0) || (state.menuItem.option_groups && state.menuItem.option_groups.length > 0)) {
      const item2 = state.menuItem
      if (state.menuItem.courses && state.menuItem.courses.length > 0) {
        item2.courses = cleanRecurCourseItems(state.menuItem.courses)
      }
      if (state.menuItem.option_groups && state.menuItem.option_groups.length > 0) {
        const options = state.menuItem.option_groups.map(option => ({
          ...option,
          selector: (option.is_multiple === 1) ? 'checkbox' : 'radio',
          selected: (option.is_multiple === 1) ? [] : null,
          req_len: (option.is_optional === 0 && option.is_multiple === 0) ? 1 : null
        }))
        item2.option_groups = options
      }
      commit(types.SET_MENU_ITEM, item2)
    }
  },

  async fetchCourseItem ({ rootGetters }, payload) {
    try {
      const { data } = await axios.post('/api/course/item', {
        restaurant_id: parseInt(rootGetters['config/rid']),
        item_id: payload.item_id,
        plu_id: payload.plu_id
      })
      if (data && data.courses && data.courses.length > 0) {
        const courses = data.courses.map(course => {
          let reqLen
          let selected
          let selector
          let multiple
          const maxLen = course.maximum_choice
          if (course.minimum_choice === 0) {
            reqLen = null
            selector = 'checkbox'
            selected = []
            if (maxLen === 1) {
              multiple = false
            } else {
              multiple = true
            }
          } else {
            reqLen = course.minimum_choice
            if (maxLen === 1) {
              selector = 'radio'
              selected = null
              multiple = false
            } else {
              selector = 'checkbox'
              selected = []
              multiple = true
            }
          }
          return {
            ...course,
            selector: selector,
            selected: selected,
            req_len: reqLen,
            max_len: maxLen,
            multiple: multiple
          }
        })
        Vue.set(payload, 'courses', courses)
      }
    } catch (e) { }
  },

  setMainCat ({ commit }, payload) {
    commit(types.SET_MAIN_CAT, payload)
  },

  showCatListDialog ({ commit }) {
    commit(types.SHOW_CAT_LIST_DIALOG)
  },

  hideCatListDialog ({ commit }) {
    commit(types.HIDE_CAT_LIST_DIALOG)
  },

  async fetchSubmenu ({ commit, rootGetters }) {
    try {
      const { data } = await axios.post('/api/getSubmenu', {
        rid: parseInt(rootGetters['config/rid'])
      })
      if (data.code === 1) {
        commit(types.FETCH_SUBMENU, data.submenu)
      }
    } catch (e) {
      console.log(e)
    }
  },

  setSelectedPanel ({ commit }, payload) {
    commit(types.SET_SELECTED_PANEL, payload)
  },

  resetSelectedPanel ({ commit }) {
    commit(types.RESET_SELECTED_PANEL)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js